<template>
  <div class="nav-header">
    <headerWeb v-if="!isMobile"></headerWeb>
    <headerMobile v-if="isMobile && moveUp"></headerMobile>
  </div>
</template>
<script>
import headerWeb from './header-web.vue'
import headerMobile from './header-mobile.vue'
export default {
  name: 'nav-header',
  data() {
    return {
      isMobile: true
    }
  },
  props: {
    moveUp: Boolean
  },
  components: {
    headerWeb,
    headerMobile
  },
  mounted() {
    const detectDeviceType = () =>
      /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
        ? 'Mobile'
        : 'Desktop'
    this.isMobile = detectDeviceType() === 'Mobile'
  },
  methods: {}
}
</script>
<style lang="less">
</style>
